import PropTypes from 'prop-types';
import React from 'react';

import makeStyles from '@glass/web/modules/theme/makeStyles';

import Link from '@glass/shared/components/Link/Link';

export const useContentLinkStyles = makeStyles()((theme) => ({
  root: {
    '&:hover': {
      color: theme.palette.secondary[400],
      textDecorationColor: theme.palette.secondary[400],
    },
  },
}));

function ContentLink({ href, target, children }) {
  const { classes } = useContentLinkStyles();
  return (
    <Link className={classes.root} href={href} target={target} underline="always">
      {children}
    </Link>
  );
}

ContentLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  target: PropTypes.string,
};

ContentLink.displayName = 'ContentLink';

export default ContentLink;
